import React from "react";

const Clock: React.FC<IconProps> = ({
  height,
  width,
  fillColor,
}) => {
  const h = height ?? 16;
  const w = width ?? 16;
  const fill = fillColor ?? "currentColor";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M0.666656 8C0.666656 3.94991 3.9499 0.666668 7.99999 0.666668C12.0501 0.666668 15.3333 3.94991 15.3333 8C15.3333 12.0501 12.0501 15.3333 7.99999 15.3333C3.9499 15.3333 0.666656 12.0501 0.666656 8ZM8.66666 4C8.66666 3.63181 8.36818 3.33333 7.99999 3.33333C7.6318 3.33333 7.33332 3.63181 7.33332 4V8C7.33332 8.25252 7.47599 8.48336 7.70185 8.59629L10.3685 9.92962C10.6978 10.0943 11.0983 9.9608 11.2629 9.63148C11.4276 9.30216 11.2941 8.90171 10.9648 8.73705L8.66666 7.58798V4Z" fill={fill}/>
    </svg>
  );
};

export default Clock;